import { Component, ViewEncapsulation, ChangeDetectionStrategy, NgZone, Input, ViewChild, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/map.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["mapContainer"];
class MapComponent {
    /**
     * @param {?} ngZone
     */
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.zoom = 15;
        this.showMarker = true;
        this.latLongChanged = false;
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        /** @type {?} */
        const enoughValues = !isNaN(this.latitude) && !isNaN(this.longitude);
        if (enoughValues) {
            if (!this.latLong || this.latitude != this.lastLatitude || this.longitude != this.lastLongitude) {
                this.latLong = new google.maps.LatLng(this.latitude, this.longitude);
                this.latLongChanged = true;
                this.lastLatitude = this.latitude;
                this.lastLongitude = this.longitude;
            }
            else
                this.latLongChanged = false;
            if (!this.map)
                this.initialize();
            else
                this.update();
        }
        else
            this.destroy();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy();
    }
    /**
     * @private
     * @return {?}
     */
    initialize() {
        this.ngZone.runOutsideAngular((/**
         * @return {?}
         */
        () => {
            // Create disposable container
            this.mapDisposableContainer = document.createElement('div');
            this.mapDisposableContainer.classList.add('disposable-container');
            ((/** @type {?} */ (this.mapContainer.nativeElement))).appendChild(this.mapDisposableContainer);
            // Instantiate map
            /** @type {?} */
            const mapProps = {
                center: this.latLong,
                zoom: this.zoom,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [{
                        featureType: 'poi.business',
                        // Hide ad markers
                        stylers: [{ visibility: 'off' }]
                    }]
            };
            this.map = new google.maps.Map(this.mapDisposableContainer, (/** @type {?} */ (mapProps)));
            // Add marker
            this.marker = new google.maps.Marker({
                position: this.latLong,
                map: this.map,
            });
        }));
    }
    /**
     * @private
     * @return {?}
     */
    update() {
        if (this.map && this.latLongChanged) {
            (/** @type {?} */ (this.map)).setCenter((/** @type {?} */ (this.latLong)));
            (/** @type {?} */ (this.marker)).setPosition((/** @type {?} */ (this.latLong)));
        }
    }
    /**
     * @private
     * @return {?}
     */
    destroy() {
        if (this.map) {
            // Detach disposable container (and map within it)
            this.mapDisposableContainer.remove();
            delete this.mapDisposableContainer;
            // Remove all references to any map related objects to avoid memory leaks
            delete this.latLong;
            delete this.map;
            // Clear lastLat and lastLong values
            delete this.lastLatitude;
            delete this.lastLongitude;
        }
    }
}
MapComponent.ɵfac = function MapComponent_Factory(t) { return new (t || MapComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
MapComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MapComponent, selectors: [["egov-map"]], viewQuery: function MapComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mapContainer = _t.first);
    } }, inputs: { zoom: "zoom", showMarker: "showMarker", latitude: "latitude", longitude: "longitude" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["id", "map-container"], ["mapContainer", ""]], template: function MapComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } }, styles: ["egov-map,egov-map #map-container,egov-map #map-container .disposable-container{display:block;width:100%;height:100%}"], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MapComponent.ctorParameters = () => [
    { type: NgZone }
];
MapComponent.propDecorators = {
    latitude: [{ type: Input }],
    longitude: [{ type: Input }],
    zoom: [{ type: Input }],
    showMarker: [{ type: Input }],
    mapContainer: [{ type: ViewChild, args: ['mapContainer', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MapComponent, [{
        type: Component,
        args: [{ selector: 'egov-map', template: "<div id=\"map-container\" #mapContainer></div>\n", encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, styles: ["egov-map,egov-map #map-container,egov-map #map-container .disposable-container{display:block;width:100%;height:100%}"] }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { zoom: [{
            type: Input
        }], showMarker: [{
            type: Input
        }], latitude: [{
            type: Input
        }], longitude: [{
            type: Input
        }], mapContainer: [{
            type: ViewChild,
            args: ['mapContainer', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    MapComponent.prototype.latitude;
    /** @type {?} */
    MapComponent.prototype.longitude;
    /** @type {?} */
    MapComponent.prototype.zoom;
    /** @type {?} */
    MapComponent.prototype.showMarker;
    /** @type {?} */
    MapComponent.prototype.mapContainer;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.mapDisposableContainer;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.lastLatitude;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.lastLongitude;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.latLongChanged;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.latLong;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.marker;
    /** @type {?} */
    MapComponent.prototype.map;
    /**
     * @type {?}
     * @private
     */
    MapComponent.prototype.ngZone;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/map.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MapModule {
}
MapModule.ɵfac = function MapModule_Factory(t) { return new (t || MapModule)(); };
MapModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MapModule });
MapModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MapModule, [{
        type: NgModule,
        args: [{
                declarations: [MapComponent],
                imports: [],
                exports: [MapComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MapModule, { declarations: [MapComponent], exports: [MapComponent] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: egovsolutions-angular-map.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MapModule, MapComponent as ɵa };

